import {
    PROFILE_COMPLETION_START,
    PROFILE_COMPLETION_SUCCESS,
    PROFILECOMPLETION_ERROR,
    PROFILECOMPLETION_RESET,

} from "./actionTypes"

const initialState = {
    completionPercentage: 0,
    errors: "",
    avatar:""
}

const profileReducer = (state = initialState, action) => {
    switch (action.type) {
        case PROFILE_COMPLETION_START:
            return {
                ...state,
                errors: ""
            }

        case PROFILE_COMPLETION_SUCCESS:
            return {
                ...state,
                completionPercentage: action.payload.percentage,
                avatar: action.payload.avatar
            }

        case PROFILECOMPLETION_ERROR:
            return {
                ...state,
                errors: action.payload,
            }
        case PROFILECOMPLETION_RESET:
            return{
                ...state,
                errors: ""
            }
            
        default:
            return state;
    }
};

export default profileReducer;